// import { traceConf } from './traceConf.js'

import { TFunction } from 'i18next'
import { WallboxHardwareModel } from 'src/Libs/wallboxes/models'
import { PowermeterHardwareDataModel } from '../../../../State/Storage/StorageModel'
import { CustomTrace } from '../../../chart-kit/shared/utils/chartModel'

export const getTraceName = (
  t: TFunction,
  customTrace: CustomTrace,
  wallboxes?: WallboxHardwareModel[],
  powermeters?: PowermeterHardwareDataModel
): string => {
  const keys = []
  const opts: Record<string, string> = {}
  const isIndividualWallboxTrace = customTrace?.alternateKey?.startsWith('wb')
  const isWallboxSumTrace = customTrace?.alternateKey?.startsWith('Wallbox')
  const isIndividualPowermeterTrace = customTrace?.alternateKey?.startsWith('pm')
  const isPowermeterSumTrace = customTrace?.alternateKey?.startsWith('Powermeter')

  if (customTrace.name) return customTrace.name

  if (isIndividualWallboxTrace) return getWallboxTraceName(t, customTrace, wallboxes)
  if (isWallboxSumTrace) return t(`systemDataHandler.trace.wallbox.${customTrace.alternateKey}_total_sum`)
  if (isIndividualPowermeterTrace) return getPowermeterTraceName(t, customTrace, powermeters)
  if (isPowermeterSumTrace) return t(`systemDataHandler.trace.powermeter.${customTrace.alternateKey}_total_sum`)

  keys.push('systemDataHandler.trace.' + customTrace.key)
  keys.push('systemDataHandler.trace.unknown')
  if (customTrace.key === 'Custom_Sum') return customTrace.alternateKey!

  return t(keys, opts)
}

export const getWallboxTraceName = (t: TFunction, customTrace: CustomTrace, wallboxes?: WallboxHardwareModel[]): string => {
  const wallboxId = customTrace?.alternateKey?.split('/')[0].slice(2)
  const traceName = customTrace?.alternateKey?.split('/')[1]
  const matchingWallboxItem = wallboxes?.find(wallbox => wallbox.number.toString() === wallboxId)
  const wallboxName = matchingWallboxItem?.deviceName
  const installationHasMultipleWallboxes = wallboxes && wallboxes.length > 1

  if (wallboxName) return t(`systemDataHandler.trace.wallbox.${traceName}_named`, { name: matchingWallboxItem.deviceName })

  if (installationHasMultipleWallboxes && wallboxId) {
    return t(`systemDataHandler.trace.wallbox.${traceName}_unnamed`, { id: wallboxId })
  }

  return t(`systemDataHandler.trace.wallbox.${traceName}_default`)
}

export const getPowermeterTraceName = (t: TFunction, customTrace: CustomTrace, powermeters?: PowermeterHardwareDataModel): string => {
  const [prefix, traceName] = customTrace.alternateKey?.split('/') || []
  const parts = prefix?.split('_') || []
  const powermeterId = parts[parts.length - 1]
  const storageId = parts.length === 3 ? parts[1] : undefined

  const matchingPowermeterItem = Object.values(powermeters || {})
    .reduce((prev, next) => [...prev, ...next], [])
    .find(powermeter => powermeter.id.toString() === powermeterId && (!storageId || powermeter.serialno?.toString() === storageId))

  const powermeterName = matchingPowermeterItem?.name?.[1]
  const installationHasMultipleProducers = powermeters && powermeters?.producers.length > 1

  if (powermeterName) return t(`systemDataHandler.trace.powermeter.${traceName}_named`, { name: powermeterName })

  if (installationHasMultipleProducers && powermeterId) return t(`systemDataHandler.trace.powermeter.${traceName}_unnamed`, { id: powermeterId })

  return t(`systemDataHandler.trace.powermeter.${traceName}_default`)
}
